import * as React from 'react'

import { cn } from '../../lib/utils'

function Kbd({ className, ...props }: React.ComponentProps<'kbd'>) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        'border-border bg-bg-elev text-2xs text-fg-subtle rounded-sm border px-1.5 py-0.5',
        className,
      )}
      {...props}
    />
  )
}

export { Kbd }
